var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.isshow)?_c('v-snackbar',{staticClass:"fixed_",attrs:{"timeout":-1,"value":true,"absolute":"","top":"","color":_vm.color,"centered":""}},[_vm._v(" "+_vm._s(_vm.content)+" ")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }